(function () {
  function init(root) {
    var track = root.querySelector('.pd-slider__track');
    if (!track) return;
    var slides = [].slice.call(root.querySelectorAll('.pd-slider__slide'));
    var dotsBox = root.querySelector('.pd-slider__dots');
    function step() {
      var s = slides[0];
      return s ? s.offsetWidth + 16 : 280;
    }
    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }
    root.querySelectorAll('.pd-slider__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        go(parseInt(btn.getAttribute('data-dir'), 10));
      });
    });
    if (dotsBox) {
      dotsBox.innerHTML = '';
      slides.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'pd-slider__dot';
        d.setAttribute('aria-label', 'Go to product ' + (i + 1));
        d.addEventListener('click', function () {
          slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsBox.appendChild(d);
      });
      function sync() {
        var idx = Math.round(track.scrollLeft / step());
        [].forEach.call(dotsBox.children, function (d, i) {
          d.classList.toggle('is-on', i === idx);
        });
      }
      track.addEventListener('scroll', sync, { passive: true });
      sync();
    }
  }
  document.querySelectorAll('[data-pd-slider]').forEach(init);
})();
